import Web3 from "web3"
import { RPC_URL } from 'constants/config'

export const useWeb3 = () => {
    return new Web3(Web3.givenProvider || new Web3.providers.HttpProvider(RPC_URL))
}